import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M108.084 500c-5.359 0-10.514-2.252-14.64-6.518L5.987 398.16C2.066 393.886 0 388.268 0 382.196a24.34 24.34 0 0 1 5.987-15.964l87.457-95.322c8.04-8.77 21.036-8.77 29.083 0s8.046 22.927 0 31.697l-52.185 57.107h244.017c38.362 0 74.666-16.417 102.309-46.093 27.016-29.676 42.078-69.466 42.078-111.286 0-86.776-64.771-157.372-144.387-157.372H25.584c-11.346 0-20.627-10.115-20.627-22.481C4.957 10.122 14.238 0 25.584 0h288.775C416.668 0 500 90.826 500 202.335c0 53.956-19.188 104.761-54.25 143.207-35.274 38.222-81.887 59.128-131.391 59.128H70.342l52.185 57.107c8.046 8.77 8.046 22.928 0 31.698-3.921 4.273-9.076 6.518-14.436 6.518z" }, null, -1)
  ])))
}
export default { render: render }